import { Pagination } from '$core/models/pagination';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

export class SearchResults {
  public highlight: string[];
  public pretty_url: string;
  public external_url: string;
  public short_content: string;
  public title: string;
  constructor(data) {
    Object.assign(this, data);
  }
}

@Injectable({
  providedIn: 'root',
})
export class MainSearchService {
  constructor(private http: HttpClient) {}

  public searchItems(search: string) {
    return this.http
      .get<any>('/v1/pages/search', { params: { search } })
      .pipe(
        map((el) => {
          el.data.map((element) => new SearchResults(element));
          return el;
        })
      )
      .toPromise();
  }

  public nextPage(url) {
    return this.http.request<Pagination<SearchResults>>('get', url);
  }
}
